import { render, staticRenderFns } from "./jgtx.vue?vue&type=template&id=5d191b23&scoped=true&"
import script from "./jgtx.vue?vue&type=script&lang=js&"
export * from "./jgtx.vue?vue&type=script&lang=js&"
import style0 from "./jgtx.vue?vue&type=style&index=0&id=5d191b23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d191b23",
  null
  
)

export default component.exports